/**
 * True when running the webpack dev server on a workstation (npm start),
 * not on deployed dev/prod hosts.
 */
export function isLocalDevEnvironment() {
  const envType =
    typeof process !== "undefined" && process.env.ENV_TYPE
      ? String(process.env.ENV_TYPE).toLowerCase()
      : "";

  if (envType === "local") return true;

  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    if (host === "localhost" || host === "127.0.0.1") return true;
  }

  return false;
}
